// extracted by mini-css-extract-plugin
export default {"AppAdminHeader":"AppAdminHeader_AppAdminHeader__pDL-g"};